import api from "./axios";

// Platform subscription tiers (Basic / Pro / Plus / Advisor).
// No payment is wired yet — setMyTier() switches the user's tier for free.
// When Stripe lands, setMyTier() becomes a Checkout redirect but the call
// shape stays the same so callers don't need to change.

// GET /api/plans/  (AllowAny) — public pricing catalog
export const listPlans = async () => {
  const res = await api.get("/api/plans/");
  return res.data;
};

// GET /api/me/tier/  (IsAuthenticated)
export const getMyTier = async () => {
  const res = await api.get("/api/me/tier/");
  return res.data; // { tier, tier_updated_at }
};

// POST /api/me/tier/  (IsAuthenticated) — body { tier }
export const setMyTier = async (tier) => {
  const res = await api.post("/api/me/tier/", { tier });
  return res.data; // { tier, tier_updated_at }
};
